import { createAction } from '@reduxjs/toolkit';

export const inspirationDimensionsToggled = 'dora/inspiration/dimensionsToggle';
export const openArDrawer = 'dora/inspiration/openArDrawer';
export const closeArDrawer = 'dora/inspiration/closeArDrawer';
export const user3dSceneInteraction = 'dora/vi/user3dSceneInteraction';
export const selectAttribute = 'dora/inspiration/selectAttribute';
export const selectOption = 'dora/inspiration/selectOption';

export const inspirationDimensionsToggledAction = createAction<{
    isVisible: boolean;
}>(inspirationDimensionsToggled);

export const openArDrawerAction = createAction<{ item_id: string }>(openArDrawer);
export const closeArDrawerAction = createAction<{ item_id: string }>(closeArDrawer);
export const user3dSceneInteractionAction = createAction(user3dSceneInteraction);
export const selectAttributeAction =
    createAction<{ attributeType: string; openPanel: boolean }>(selectAttribute);
export const selectOptionAction =
    createAction<{ optionValue: string; compatible: boolean; currentProductId?: string }>(
        selectOption,
    );
